module.exports = __webpack_public_path__ + "images/sgp/10x10/relatedContent/10x15-storage-unit.webp";